/* Great Creations, mode toggle behavior. Init already ran inline in <head>. */
(function () {
  function current() {
    return document.documentElement.getAttribute('data-gc-mode') === 'dark' ? 'dark' : 'light';
  }
  function set(mode) {
    document.documentElement.setAttribute('data-gc-mode', mode);
    try {
      // STRICT opt-in: localStorage only after the visitor said SWEET.
      // Everyone else gets session-only memory.
      if (localStorage.getItem('gcCookieChoice') === 'ok') {
        localStorage.setItem('gcMode', mode);
      } else {
        sessionStorage.setItem('gcMode', mode);
      }
    } catch (e) {}
    document.querySelectorAll('[data-gc-mode-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
    });
  }
  window.gcToggleMode = function () { set(current() === 'dark' ? 'light' : 'dark'); };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gc-mode-toggle]');
    if (btn) { e.preventDefault(); window.gcToggleMode(); }
  });
  // sync aria-pressed on load
  document.addEventListener('DOMContentLoaded', function () { set(current()); });

  // Fix for Spotlight's localization dropdown: the header variant focuses
  // its search box on open and closes on focusout. In Chromium, mousedown
  // on a link or scrollbar blurs the box without moving focus anywhere the
  // component recognizes, so the panel vanishes mid-click. Preventing the
  // default focus shift (same trick core uses on its reset button) keeps
  // focus inside; clicks and scrolling still work, outside-click still
  // closes, and typing in the search box is untouched.
  document.addEventListener(
    'mousedown',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var panel = e.target.closest('localization-form .disclosure__list-wrapper');
      if (panel && !e.target.closest('input, textarea, select')) {
        e.preventDefault();
      }
    },
    true
  );
})();

/* GC recently-viewed recorder: on product pages, note the handle in the
   visitor's own trail. Consent-aware like gcMode: localStorage only after
   the cookie-cousin banner's SWEET (gcCookieChoice === 'ok'), otherwise
   sessionStorage. Newest first, unique, capped at 8. */
(function () {
  var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = decodeURIComponent(m[1]);
  var KEY = 'gcRecent';
  var consented = false;
  try { consented = localStorage.getItem('gcCookieChoice') === 'ok'; } catch (e) {}
  var raw = null;
  try { raw = sessionStorage.getItem(KEY) || localStorage.getItem(KEY); } catch (e) {}
  var list = [];
  if (raw) { try { list = JSON.parse(raw) || []; } catch (e) { list = []; } }
  list = list.filter(function (h) { return h !== handle; });
  list.unshift(handle);
  list = list.slice(0, 8);
  try {
    var out = JSON.stringify(list);
    if (consented) { localStorage.setItem(KEY, out); sessionStorage.removeItem(KEY); }
    else { sessionStorage.setItem(KEY, out); }
  } catch (e) {}
})();
